if(!window.__bcHomeInit){window.__bcHomeInit=1;
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.bch-prods .carousel').forEach(function(car){
    var cards=car.querySelectorAll('.bch-card');if(cards.length<2)return;
    var dots=car.parentElement.querySelector('.dots');if(!dots)return;
    var perView=window.matchMedia('(min-width:900px)').matches?4:1;
    var pages=Math.max(1,Math.ceil(cards.length/perView));
    if(pages<2){dots.style.display='none';return}
    dots.innerHTML='';
    for(var i=0;i<pages;i++){var d=document.createElement('i');if(i===0)d.className='on';dots.appendChild(d)}
    car.addEventListener('scroll',function(){
      var idx=Math.round(car.scrollLeft/(car.scrollWidth-car.clientWidth)*(pages-1))||0;
      dots.querySelectorAll('i').forEach(function(el,j){el.className=j===idx?'on':''});
    },{passive:true});
  });
});
}
